import { StackedBarHorizontalChart } from "components";
import { useMemo } from "react";
import { formatNumber } from "utils/formatNumber";

const NumberOfShareholderDistributionSection = ({ data }) => {
  const chartData = useMemo(
    () => ({
      labels: ["Public (< 5%)", "Ownership more than 5%"],
      datasets: [
        {
          label: "Non-affiliated shareholders (public)",
          data: [{ x: data?.non_affiliated_shareholders, y: "Public (< 5%)" }],
          stack: "Stack 0",
          backgroundColor: "#2DC48D",
          borderRadius: {
            topLeft: 12,
            bottomLeft: 12,
            ...(!data?.affiliated_shareholders
              ? { topRight: 12, bottomRight: 12 }
              : {}),
          },
          datalabels: {
            display: false,
          },
        },
        {
          label: "Affiliated shareholders (public)",
          data: [{ x: data?.affiliated_shareholders, y: "Public (< 5%)" }],
          stack: "Stack 0",
          backgroundColor: "#FFB703",
          borderRadius: { topRight: 12, bottomRight: 12 },
          borderSkipped: false,
          datalabels: {
            anchor: "end",
            align: "end",
            formatter: function (value) {
              return formatNumber.toAmount(
                Number(value?.x || 0) +
                  Number(data?.non_affiliated_shareholders || 0),
              );
            },
          },
        },
        {
          label: "Ownership more than 5%",
          data: [
            { x: data?.ownership_more_than_5, y: "Ownership more than 5%" },
          ],
          backgroundColor: "#3DA2F3",
          showLegend: false,
        },
      ],
    }),
    [data],
  );

  return (
    <div className='section h-full'>
      <p className='font-bold text-lg mb-6'>
        Number of Shareholder Distribution
      </p>
      <StackedBarHorizontalChart
        id='number-shareholder-distribution-chart'
        data={chartData}
      />
      <div className='flex flex-row gap-6'>
        <div className='flex flex-col gap-2'>
          <div className='flex flex-row gap-2 items-center'>
            <div className='rounded-full w-2 h-2 bg-[#2DC48D]' />
            <p className='text-[#5F737F] text-sm'>
              Non-affiliated shareholders
            </p>
          </div>
          <p className='pl-4'>{data?.non_affiliated_shareholders}</p>
        </div>

        <div className='flex flex-col gap-2'>
          <div className='flex flex-row gap-2 items-center'>
            <div className='rounded-full w-2 h-2 bg-[#FFB703]' />
            <p className='text-[#5F737F] text-sm'>Affiliated shareholders</p>
          </div>
          <p className='pl-4'>{data?.affiliated_shareholders}</p>
        </div>
      </div>
    </div>
  );
};

export default NumberOfShareholderDistributionSection;
